import { ComponentFactoryResolver, ComponentRef, Directive, EmbeddedViewRef, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { InfoTipWrapperComponent } from './info-tip-wrapper/info-tip-wrapper.component';
import { InfoTipService } from './info-tip.service';

type InfoTipDirectiveContext = any;

@Directive(
	{
		exportAs: 'dag-info-tip'
		, selector: '[infoTip]'
	}
)
export class InfoTip
	implements OnInit, OnDestroy {

	@Input()
	private readonly infoTip: string;

	@Input()
	private readonly infoTipShowIcon: boolean;

	private wrapperRef: ComponentRef<InfoTipWrapperComponent>;
	// private embeddedViewRef: EmbeddedViewRef<InfoTipDirectiveContext>;

	public constructor(
		private readonly infoTipService: InfoTipService,
		private readonly templateRef: TemplateRef<InfoTipDirectiveContext>,
		private readonly viewContainer: ViewContainerRef,
		private readonly componentFactoryResolver: ComponentFactoryResolver
	) {
	}

	public ngOnInit() {
		const view = this.viewContainer.createEmbeddedView(this.templateRef);
		view.detach();

		this.wrapperRef = this.viewContainer.createComponent<InfoTipWrapperComponent>(
			this.componentFactoryResolver.resolveComponentFactory(
				InfoTipWrapperComponent
			)
		);

		this.wrapperRef.instance.elseLabel = this.infoTip;
		this.wrapperRef.instance.showIcon = this.infoTipShowIcon || false;
		this.wrapperRef.instance.info$ = this.infoTipService.getInfo$(this.infoTip);

		view.reattach();
	}

	ngOnDestroy() {
		this.wrapperRef.destroy();
		// this.embeddedViewRef.destroy();
	}
}
